export default __webpack_public_path__ + "static/media/valley2.20c52c17.png";